export const CustomerData = [
  {
    cardHeight: "490px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-hep-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-higer-new.png",
    cardQuote: "customer.home.cardList.item1.text",
    url: "/customer/hep",
    alt: "出版业单点登录",
  },
  {
    cardHeight: "450px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-yuanqi-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-yuanqi-forest.png",
    cardQuote: "customer.home.cardList.item2.text",
    url: "/customer/yuanqi",
    alt: "消费行业单点登录",
  },
  {
    cardHeight: "450px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-cnpn-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-cnpc-new.png",
    cardQuote: "customer.home.cardList.item3.text",
    url: "/customer/cnpn",
    alt: "能源业单点登录",
  },
  {
    cardHeight: "400px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-southeast-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-dongnan-new.png",
    cardQuote: "customer.home.cardList.item4.text",
    url: "/customer/southeast-university",
    alt: "教育业身份管理方案",
  },
  {
    cardHeight: "340px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-volkswagen-bg.png",
    imgUrl: "//files.authing.co/authing-website/vw.png",
    cardQuote: "customer.home.cardList.item5.text",
    url: "/customer/volkswagen",
    alt: "汽车业身份管理体系",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-bentleymotor-bg.png",
    imgUrl: "//files.authing.co/authing-website/bentleymotors.png",
    cardQuote: "customer.home.cardList.item6.text",
    url: "/customer/bentley-motors",
    alt: "汽车业身份解决方案",
  },
  {
    cardHeight: "400px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-toyota-bg.png",
    imgUrl: "//files.authing.co/authing-website/brand-toyota-red.svg",
    cardQuote: "customer.home.cardList.item7.text",
    url: "/customer/toyota",
    alt: "汽车业权限访问管理",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-jcdecaux-bg.png",
    imgUrl: "//files.authing.co/authing-website/brand-logo-jcdecaux.png",
    cardQuote: "customer.home.cardList.item8.text",
    url: "/customer/jcdecaux",
    alt: "传媒业身份管理体系",
  },
  {
    cardHeight: "480px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-bosch-bg.png",
    imgUrl: "//files.authing.co/authing-website/customer-logo-bosch.png",
    cardQuote: "customer.home.cardList.item9.text",
    url: "/customer/bosch",
    alt: "制造业单点登录",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-pingcap-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-pingcap.png",
    cardQuote: "customer.home.cardList.item10.text",
    url: "/customer/pingcap",
    alt: "企业服务行业单点登录",
  },
  {
    cardHeight: "480px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-huaxi-bg.png",
    imgUrl: "//files.authing.co/authing-website/logo-sichuan-university.png",
    cardQuote: "customer.home.cardList.item11.text",
    url: "/customer/west-china-hospital",
    alt: "医疗业统一身份认证",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-bentley-bg-v2.png",
    imgUrl: "//files.authing.co/authing-website/brand-bentley.png",
    cardQuote: "customer.home.cardList.item12.text",
    url: "/customer/bentley",
    alt: "制造业身份管理",
  },
  {
    cardHeight: "480px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-nreal-bg.png",
    imgUrl: "https://files.authing.co/authing-website/customer-logo-nreal.png",
    cardQuote: "customer.home.cardList.item13.text",
    url: "/customer/nreal",
    alt: "authing",
  },
  {
    cardHeight: "480px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-seer-bg.png",
    imgUrl: "https://files.authing.co/authing-website/manu-1-logo5.png",
    cardQuote: "customer.home.cardList.item14.text",
    url: "/customer/seer",
    alt: "authing",
  },
  {
    cardHeight: "380px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-alpha-bg.png",
    imgUrl: "https://files.authing.co/authing-website/manu-1-logo7-k.png",
    cardQuote: "customer.home.cardList.item15.text",
    url: "/customer/alpha-cen",
    alt: "authing",
  },
  {
    cardHeight: "480px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-csdn-bg.png",
    imgUrl: "https://files.authing.co/authing-website/banner-logo-csdn.png",
    cardQuote: "customer.home.cardList.item16.text",
    url: "/customer/csdn",
    alt: "authing",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-unicredit-bg.png",
    imgUrl: "https://files.authing.co/authing-website/finance-yuxin.png",
    cardQuote: "customer.home.cardList.item17.text",
    url: "/customer/unicredit",
    alt: "authing",
  },
];
